import {
  call, put, select, takeEvery,
} from 'redux-saga/effects';
import { get } from 'lodash';
import findResult, { createOrderByParams } from '@/utils/resultsHelper';
import selectors from '@/selectors';
import AuditService from '../service';
import {
  showAudits,
  showAuditsError,
} from '../actions';
import actions from '../constants';

function fetchAudits(category, code, filters, page, pageSize, orderBy) {
  return AuditService.audits(category, code, filters, page, pageSize, orderBy)
    .then((response) => ({ response }))
    .catch((error) => ({ error }));
}

export function* audits(action) {
  const items = yield select(selectors.audits);
  const {
    filters, pageSize, currentPage, orderBy,
  } = findResult(items, action.category, action.code);
  const page = action.page || currentPage;
  const size = action.pageSize || pageSize;
  const orderByParams = createOrderByParams(orderBy);
  const { response, error } = yield call(
    fetchAudits,
    action.category,
    action.code,
    filters,
    page,
    size,
    orderByParams,
  );

  if (error) {
    yield put(showAuditsError(action.category, action.code, error));
  } else {
    yield put(showAudits(
      action.category,
      action.code,
      get(response.additional, `${action.category}.name`, ''),
      action.append,
      size,
      response.items,
      response.paging.total,
      response.paging.pages,
      response.paging.page,
    ));
  }
}

export default function* auditApi() {
  yield takeEvery(
    [
      actions.FETCH_AUDITS,
      actions.REFRESH_AUDITS,
      actions.TOGGLE_AUDITS_COLUMN_ORDER_BY,
      actions.TOGGLE_AUDITS_SINGLE_SORTING,
      actions.SWITCH_ENTITY_FILTER,
    ],
    audits,
  );
}
